import React, { memo, useCallback } from 'react'
import { UploadBankInformation, UploadDebitCard } from 'src/constants/actionTypes'
import { BankPaymentForm } from 'src/components/bank-payment-form/BankPaymentForm'
import {
  BankInformationRequest,
  DebitCardRequest,
} from 'src/components/bank-payment-form/BankPaymentForm.interface'
import { ClientSecureWrapper } from 'src/components/layout/client/ClientSecureWrapper'
import { useAsyncDispatchWithErrorToast } from 'src/hooks/useAsyncDispatchWithErrorToast'
import { useSelector } from 'react-redux'
import { getDriver } from 'src/selectors/driver'
import { DataCollectionSource } from 'src/constants/shared'

const BankPaymentComponent = () => {
  const driver = useSelector(getDriver)

  const { asyncDispatchWithErrorToast } = useAsyncDispatchWithErrorToast('client')

  const handleSubmitDebitCard = useCallback(
    async (requestBody: DebitCardRequest) => {
      await asyncDispatchWithErrorToast(UploadDebitCard.request(requestBody))
    },
    [asyncDispatchWithErrorToast],
  )

  const handleSubmitBankInformation = useCallback(
    async (requestBody: BankInformationRequest) => {
      await asyncDispatchWithErrorToast(UploadBankInformation.request(requestBody))
    },
    [asyncDispatchWithErrorToast],
  )

  return (
    <ClientSecureWrapper>
      <BankPaymentForm
        title="Get paid!"
        description="To receive payouts and process transactions, you'll need to add a valid payment method. Choose between a debit card or bank account and fill out the details below."
        showIcon={true}
        showStepIndex={true}
        showCurrentPaymentMethod={driver?.collectDataFlow === DataCollectionSource.Recollection}
        flow="client"
        onSubmitDebitCard={handleSubmitDebitCard}
        onSubmitBankInformation={handleSubmitBankInformation}
      />
    </ClientSecureWrapper>
  )
}

export const BankPaymentPage = memo(BankPaymentComponent)
